import { Action } from '@ngrx/store';

export const ACTIVE_NAVIGATION_ITEM = '[GOSUITE:SIDEBAR] ACTIVE_NAVIGATION_ITEM';
export const ACTIVE_NAVIGATION_MENU_ITEM = '[GOSUITE:SIDEBAR] ACTIVE_NAVIGATION_MENU_ITEM';
export const TOGGLE_NAVIGATION = '[GOSUITE:SIDEBAR] TOGGLE_NAVIGATION';
export const OPEN_NAVIGATION = '[GOSUITE:SIDEBAR] OPEN_NAVIGATION';
export const CLOSE_NAVIGATION = '[GOSUITE:SIDEBAR] CLOSE_NAVIGATION';
export const TOGGLE_ADMIN_SECTION = '[GOSUITE:SIDEBAR] TOGGLE_ADMIN_SECTION';
export const OPEN_ADMIN_SECTION = '[GOSUITE:SIDEBAR] OPEN_ADMIN_SECTION';
export const CLOSE_ADMIN_SECTION = '[GOSUITE:SIDEBAR] CLOSE_ADMIN_SECTION';
export const TOGGLE_ADDONS_SECTION = '[GOSUITE:SIDEBAR] TOGGLE_ADDONS_SECTION';
export const OPEN_ADDONS_SECTION = '[GOSUITE:SIDEBAR] OPEN_ADDONS_SECTION';
export const CLOSE_ADDONS_SECTION = '[GOSUITE:SIDEBAR] CLOSE_ADDONS_SECTION';

export class SetActiveNavigationItem implements Action {
	readonly type = ACTIVE_NAVIGATION_ITEM;

	constructor(public item: string) {}
}

export class SetActiveNavigationMenuItem implements Action {
	readonly type = ACTIVE_NAVIGATION_MENU_ITEM;

	constructor(public item: string) {}
}

export class ToggleNavigationExpanded implements Action {
	readonly type = TOGGLE_NAVIGATION;
}

export class OpenNavigation implements Action {
	readonly type = OPEN_NAVIGATION;
}

export class CloseNavigation implements Action {
	readonly type = CLOSE_NAVIGATION;
}

export class ToggleAdminSection implements Action {
	readonly type = TOGGLE_ADMIN_SECTION;
}

export class OpenAdminSection implements Action {
	readonly type = OPEN_ADMIN_SECTION;
}

export class CloseAdminSection implements Action {
	readonly type = CLOSE_ADMIN_SECTION;
}

export class OpenAddonsSection implements Action {
	readonly type = OPEN_ADDONS_SECTION;
}

export class CloseAddonsSection implements Action {
	readonly type = CLOSE_ADDONS_SECTION;
}

export type All
	= SetActiveNavigationItem
	| SetActiveNavigationMenuItem
	| ToggleNavigationExpanded
	| OpenNavigation
	| CloseNavigation
	| ToggleAdminSection
	| OpenAdminSection
	| CloseAdminSection
	| OpenAddonsSection
	| CloseAddonsSection;



// WEBPACK FOOTER //
// ./src/app/shared/state-management/actions/sidebar.ts